import {
  Checkbox,
  FormControl,
  FormHelperText,
  InputLabel,
  ListItemIcon,
  ListItemText,
  makeStyles,
  MenuItem,
  Select,
  IconButton,
  Button,
  OutlinedInput,
} from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { createIdFromLabel, generateRandomId } from '../../../utils/commonUtils';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import '../custom-multi-select/Custom-Multi-Select.scss';

const CustomMultiSelectCrud = (props) => {
  const {
    item,
    options,
    labelField,
    valueField,
    labelPrefix,
    disabled,
    isSearchable = false,
    handleCreate,
    handleEditTag,
    handleDeleteTag,
    handleInputChange,
    classNameProps = '',
  } = props;
  const [selected, setSelected] = useState([]);
  const [addType, setAddType] = useState('');
  const [isShowAddBox, setIsShowAddBox] = useState(false);
  const [editMode, setEditMode] = useState(null);
  const inputRef = useRef(null);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center',
    },
    variant: 'menu',
    autoFocus: isSearchable ? false : true,
  };

  useEffect(() => {
    const currSelected = item?.value || [];
    setSelected(currSelected);
  }, [item?.value]);

  useEffect(() => {
    if (isShowAddBox && editMode && inputRef?.current) {
      inputRef?.current?.focus();
      const len = inputRef?.current?.value?.length;
      inputRef?.current?.setSelectionRange(len, len);
    }
  }, [isShowAddBox, editMode]);

  const fieldId = item?.fieldName ? createIdFromLabel(item.fieldName) : generateRandomId();

  const getErrorMessage = () => {
    const errorMsgs = [];
    item?.validations?.forEach((validation) => {
      if (item.errors[validation]) {
        errorMsgs.push(item.errors[validation]);
      }
    });
    return errorMsgs.length > 0 ? errorMsgs[0] : null;
  };
  const handleConfirm = () => {
    if (editMode?.id && addType.trim()) {
      handleEditTag(addType, editMode?.id);
    }
    if (addType.trim() && !editMode) {
      handleCreate(addType);
    }
    setAddType('');
    setIsShowAddBox(false);
    setEditMode(null);
  };
  const handleEdit = (index, e) => {
    e?.stopPropagation();
    setEditMode(options[index]);
    setAddType(options[index]?.name);
    setIsShowAddBox(true);
  };
  const handleChange = (checkItem, isChecked, id) => {
    if (isChecked) {
      let index = selected?.findIndex((item) => item?.id === id);
      selected.splice(index, 1);
    } else {
      selected.push(checkItem);
    }
    setSelected([...selected]);
    handleInputChange(selected);
  };
  return (
    <FormControl
      className='custom-multi-select w-100'
      required={item?.validations && item?.validations.includes('required')}
      error={getErrorMessage() ? true : false}
    >
      <InputLabel id={fieldId + '_label'}>
        {labelPrefix} {item?.fieldName}
      </InputLabel>
      <Select
        disabled={disabled}
        labelId={fieldId + '_label'}
        id={fieldId + '_select'}
        multiple
        value={selected}
        renderValue={(selected) => selected?.map((item) => item.name).join(', ')}
        MenuProps={MenuProps}
      >
        {isShowAddBox ? (
          <>
            <div className='addNewType'>
              <Button
                type='text'
                onClick={() => {
                  handleConfirm();
                }}
              >
                <u> Confirm</u>
              </Button>
              <Button
                type='text'
                onClick={() => {
                  setIsShowAddBox(false);
                  setEditMode(null);
                  setAddType('');
                }}
              >
                <u>Cancel</u>
              </Button>
            </div>
            <MenuItem className='custom-multi-select-list addNewType' value={addType}>
              <ListItemIcon>
                <Checkbox
                  color='primary'
                  checked={false}
                  // onChange={handleChange}
                />
              </ListItemIcon>
              <input
                ref={inputRef}
                type='text'
                placeholder='Enter Type Name'
                className='addTypeTextBox'
                value={addType}
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
                onChange={(e) => {
                  setAddType(e.target.value);
                }}
              />
            </MenuItem>
          </>
        ) : (
          <div className='addNewType'>
            <Button
              type='text'
              onClick={() => {
                setIsShowAddBox(true);
              }}
              style={{ color: '#828282' }}
            >
              <u> + Add New</u>
            </Button>
          </div>
        )}
        {options?.map((activity, index) => {
          if (editMode?.id === activity?.id) {
            return <></>;
          }
          let isChecked = !!selected.find((selectedItem) => selectedItem.id == activity?.id);
          return (
            <MenuItem
              className='custom-multi-select-list '
              key={activity.id}
              value={activity[valueField || 'id']}
              onClick={() => handleChange(activity, isChecked, activity?.id)}
            >
              <ListItemIcon>
                <Checkbox color='primary' checked={isChecked} />
              </ListItemIcon>
              <ListItemText primary={activity[labelField || 'name']} className={classNameProps} />
              <IconButton
                style={{ padding: 4, zIndex: 3 }}
                onClick={(e) => {
                  handleEdit(index, e);
                }}
              >
                <EditIcon sx={{ fontSize: 14 }} />
              </IconButton>
              <IconButton
                style={{ padding: 4, zIndex: 3, marginRight: 23 }}
                onClick={(e) => {
                  e?.stopPropagation();
                  handleDeleteTag(activity?.id);
                }}
              >
                <DeleteForeverIcon sx={{ fontSize: 14 }} />
              </IconButton>
            </MenuItem>
          );
        })}
      </Select>
      <FormHelperText>{getErrorMessage()}</FormHelperText>
    </FormControl>
  );
};

export default CustomMultiSelectCrud;
